
import { Vue, Component, Prop } from 'vue-property-decorator';
import { DomainData } from '@/types';
import ChapterBox from '@/components/ChapterBox.vue';
import { RouteName } from '../enums';

@Component({
	components: {
		ChapterBox
	}
})
export default class Domain extends Vue {
	@Prop() data!: DomainData;

	private goToChapter(chapterId: number) {
		this.$router.push({
			name: RouteName.CHAPTER,
			params: {
				domainId: this.data.id.toString(),
				chapterId: chapterId.toString()
			}
		});
	}
}
